import {
  Datagrid,
  TextField,
  // SearchInput,
  TextInput,
  // SelectInput,
  useTranslate,
  DateInput,
  useStore,
  // FunctionField,
  // BooleanInput,
  // BooleanField,
  // NumberField,
  // FunctionField,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { BranchSelect } from '../../components/app-bar/type'
import { DateField, NameField } from '../../components/fields'
import { TEMPORARYREQUEST_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import dayjs from 'dayjs'
import { ActionButton } from '../../components/list-actions'
// import { ActionButton } from '../../components/list-actions'

const TemperaryRequestListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${TEMPORARYREQUEST}.name`)}
    // />,
    <DateInput
      key={1}
      source='start_date'
      alwaysOn
      label={translate(`${TEMPORARYREQUEST_FIELDS}.start_date`)}
    />,
    <DateInput
      key={2}
      source='end_date'
      alwaysOn
      label={translate(`${TEMPORARYREQUEST_FIELDS}.end_date`)}
    />,
    <TextInput key={3} source='book_id' label={translate(`${TEMPORARYREQUEST_FIELDS}.book_id`)} />,
    <TextInput
      key={4}
      source='fname_lname'
      label={translate(`${TEMPORARYREQUEST_FIELDS}.fname_lname`)}
    />,
    <TextInput key={5} source='tel' label={translate(`${TEMPORARYREQUEST_FIELDS}.tel`)} />,
    <TextInput key={6} source='email' label={translate(`${TEMPORARYREQUEST_FIELDS}.email`)} />,
    // <SelectInput
    //   key={7}
    //   label={`${TEMPORARYREQUEST_FIELDS}.status.label`}
    //   source='status'
    //   choices={[
    //     { id: 'pending', name: `${TEMPORARYREQUEST_FIELDS}.status.choices.pending` },
    //     { id: 'confirm', name: `${TEMPORARYREQUEST_FIELDS}.status.choices.confirm` },
    //     { id: 'cancel', name: `${TEMPORARYREQUEST_FIELDS}.status.choices.cancel` },
    //     { id: 'reserve', name: `${TEMPORARYREQUEST_FIELDS}.status.choices.reserve` },
    //     { id: 'temporary_request', name: `${TEMPORARYREQUEST_FIELDS}.status.choices.temporary_request` },
    //   ]}
    // />,
  ]
}

const TemperaryRequestList = (): JSX.Element => {
  const [globalBranch] = useStore<BranchSelect>('branch.selected')
  const currentDate = dayjs().format('YYYY-MM-DD')
  // const translate = useTranslate()
  return (
    <ListBase
      listAction={{
        hasExport: false,
        hasCreate: false,
        
      }}
      filter={{ branch_codes: globalBranch?.id }}
      filterDefaultValues={{
        start_date: currentDate,
        end_date: currentDate,
      }}
      filters={TemperaryRequestListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick={null} bulkActionButtons={false}>
        <TextField
          source='book_id'
          label={`${TEMPORARYREQUEST_FIELDS}.book_id`}
          sortable={false}
        ></TextField>
        <NameField
          firstNameSource='first_name'
          lastNameSource='last_name'
          source='first_name'
          label={`${TEMPORARYREQUEST_FIELDS}.name`}
          sortable={false}
        />
        <TextField
          source='tel'
          label={`${TEMPORARYREQUEST_FIELDS}.tel`}
          sortable={false}
        ></TextField>
        <TextField
          source='email'
          label={`${TEMPORARYREQUEST_FIELDS}.email`}
          sortable={false}
        ></TextField>
        <DateField
          source='booking_date'
          label={`${TEMPORARYREQUEST_FIELDS}.booking_date`}
          // showTime
          // textAlign='center'
        />
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          showTime
          // textAlign='center'
        />
        <ActionButton showButton={false} deleteButton={false} />
      </Datagrid>
    </ListBase>
  )
}

export default TemperaryRequestList
